import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleScrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <nav
      className={`fixed w-full z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md py-4' : 'bg-transparent py-6'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center">
          <Link to="/" className="flex items-center space-x-3">
            <img
              src="https://public.readdy.ai/ai/img_res/ac719232-b075-4707-a7e2-7b96eb345e3b.png"
              alt="Logo"
              className="h-7 w-7 object-contain"
            />
            <span
              className={`text-sm font-bold transition-colors duration-300 whitespace-nowrap ${
                isScrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              アングリング・アクアティクス
            </span>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <a
              href="#home"
              onClick={(e) => handleScrollToSection(e, 'home')}
              className={`text-sm font-medium transition-colors duration-300 hover:text-teal-500 cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              ホーム
            </a>
            <a
              href="#blog"
              onClick={(e) => handleScrollToSection(e, 'blog')}
              className={`text-sm font-medium transition-colors duration-300 hover:text-teal-500 cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              ブログ
            </a>
            <a
              href="#featured"
              onClick={(e) => handleScrollToSection(e, 'featured')}
              className={`text-sm font-medium transition-colors duration-300 hover:text-teal-500 cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              注目記事
            </a>
            <a
              href="#about"
              onClick={(e) => handleScrollToSection(e, 'about')}
              className={`text-sm font-medium transition-colors duration-300 hover:text-teal-500 cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              運営者のプロフィール
            </a>
            <a
              href="#contact"
              onClick={(e) => handleScrollToSection(e, 'contact')}
              className={`text-sm font-medium transition-colors duration-300 hover:text-teal-500 cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              お問い合わせ
            </a>
            <Link
              to="/privacy-policy"
              className={`text-sm font-medium transition-colors duration-300 hover:text-teal-500 cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              プライバシーポリシー
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden p-2 rounded-lg transition-colors duration-300 ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}
          >
            <div className="w-6 h-5 flex flex-col justify-between">
              <span className={`w-full h-0.5 bg-current transition-all duration-300 ${isMobileMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
              <span className={`w-full h-0.5 bg-current transition-all duration-300 ${isMobileMenuOpen ? 'opacity-0' : ''}`}></span>
              <span className={`w-full h-0.5 bg-current transition-all duration-300 ${isMobileMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
            </div>
          </button>
        </div>

        {/* Mobile Menu */}
        <div
          className={`md:hidden transition-all duration-300 overflow-hidden ${
            isMobileMenuOpen ? 'max-h-96' : 'max-h-0'
          }`}
        >
          <div className={`px-4 py-4 space-y-3 ${isScrolled ? 'bg-white' : 'bg-gray-900/95'}`}>
            <a
              href="#home"
              onClick={(e) => handleScrollToSection(e, 'home')}
              className={`block py-2 text-sm font-medium transition-colors duration-300 hover:text-teal-500 cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              ホーム
            </a>
            <a
              href="#blog"
              onClick={(e) => handleScrollToSection(e, 'blog')}
              className={`block py-2 text-sm font-medium transition-colors duration-300 hover:text-teal-500 cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              ブログ
            </a>
            <a
              href="#featured"
              onClick={(e) => handleScrollToSection(e, 'featured')}
              className={`block py-2 text-sm font-medium transition-colors duration-300 hover:text-teal-500 cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              注目記事
            </a>
            <a
              href="#about"
              onClick={(e) => handleScrollToSection(e, 'about')}
              className={`block py-2 text-sm font-medium transition-colors duration-300 hover:text-teal-500 cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              運営者のプロフィール
            </a>
            <a
              href="#contact"
              onClick={(e) => handleScrollToSection(e, 'contact')}
              className={`block py-2 text-sm font-medium transition-colors duration-300 hover:text-teal-500 cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              お問い合わせ
            </a>
            <Link
              to="/privacy-policy"
              onClick={() => setIsMobileMenuOpen(false)}
              className={`block py-2 text-sm font-medium transition-colors duration-300 hover:text-teal-500 cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              プライバシーポリシー
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
